<template>
    <b-form-group :label="label" label-for="stages">
        <multiselect
            id="stages"
            :state="state"
            :selected="value"
            :options="options"
            :disabled="disabled"
            :placeholder="placeholder"
            :loading="isLoading"
            @click="getStages"
            @changeValue="onChangeValue"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label }}</span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import moment from 'moment'
import api from '@/services/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'

export default {
    name: 'Stages',
    components: {
        Multiselect,
    },
    props: {
        value: {
            required: true,
            type: Array,
        },
        state: {
            default: null,
            type: Boolean,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        label: {
            default: null,
            type: String,
        },
        placeholder: {
            default: null,
            type: String,
        },
        loadDataWhenMounted: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            options: [],
            isLoading: false,
        }
    },
    mounted() {
        if (this.loadDataWhenMounted) {
            this.getStages()
        }
    },
    methods: {
        onChangeValue(value) {
            this.$emit('update:value', value)
            this.$emit('change')
        },
        getStages() {
            if (this.options.length) {
                return
            }

            this.isLoading = true
            const today = moment().format('YYYY-MM-DD')
            api.get('/periods/all/events', {
                params: {
                    sortedBy: 'asc',
                    orderBy: 'start_date',
                    search: `period.start_date:${today};period.end_date:${today};event_type:stage_definition`,
                    and: 'yes',
                },
            })
                .then(resp => {
                    this.options = mapperToOptions(
                        resp.data.data,
                        undefined,
                        'title'
                    )
                })
                .finally(() => {
                    this.isLoading = false
                    this.$emit('options-loaded', this.options)
                })
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';

.c-th:hover {
    cursor: pointer;
}
</style>
